import { Link } from "react-router";
import { brandAsset } from "@mashriqain/brand";
import { nav, site } from "@/content/site";
import { ventures } from "@/content/ventures";
import styles from "./Footer.module.css";

export function Footer() {
  return (
    <footer className={`theme-ink ${styles.footer}`}>
      <div className={`container ${styles.inner}`}>
        <div className={styles.top}>
          <div className={styles.signature}>
            <img
              src={brandAsset("logo-horizontal-ivory.svg")}
              alt={site.name}
              className={styles.logo}
              width={979}
              height={210}
              loading="lazy"
            />
            <p className={styles.about}>{site.description}</p>
          </div>

          <div className={styles.columns}>
            <div>
              <h2 className="mono">Companies</h2>
              <ul role="list" className={styles.list}>
                {ventures.map((v) => (
                  <li key={v.slug}>
                    <Link to={`/ventures/${v.slug}`}>{v.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h2 className="mono">The group</h2>
              <ul role="list" className={styles.list}>
                {nav.map((item) => (
                  <li key={item.to}>
                    <Link to={item.to}>{item.label}</Link>
                  </li>
                ))}
                <li>
                  <Link to="/docs">Developers</Link>
                </li>
              </ul>
            </div>
            <div>
              <h2 className="mono">Correspondence</h2>
              <ul role="list" className={styles.list}>
                <li>
                  <a href={`mailto:${site.email}`}>{site.email}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className={`display ${styles.giant}`} aria-hidden="true">
          {site.name}
        </p>

        <div className={styles.bottom}>
          <p className="mono">
            © {new Date().getFullYear()} {site.name}
          </p>
          <p className={`ar ${styles.made}`} lang="ar" dir="rtl">
            صُنِعَ بإتقان
          </p>
        </div>
      </div>
    </footer>
  );
}
